<template>
  <v-container class="pd16">
    <strong class="t-cont-title">자동출금 동의정보</strong>
    <p class="aw-notice">자동출금 신청 및 출금계좌 정보입니다.</p>

    <div class="aw-loading" v-if="agreementLoading">
      <v-progress-circular indeterminate color="#ef761d" size="28" />
      <p>동의정보를 불러오는 중입니다...</p>
    </div>

    <table class="t-table table1" v-else-if="agreement">
      <colgroup>
        <col width="110px" />
        <col width="*" />
      </colgroup>
      <tr>
        <th>예금주</th>
        <td>{{ dash(agreement.account_name) }}</td>
      </tr>
      <tr>
        <th>은행</th>
        <td>{{ dash(agreement.bank_name) }}</td>
      </tr>
      <tr>
        <th>계좌번호</th>
        <td>{{ dash(agreement.account_number) }}</td>
      </tr>
      <tr>
        <th>휴대폰번호</th>
        <td>{{ mobile(agreement.contractor_mobile) }}</td>
      </tr>
      <tr>
        <th>동의상태</th>
        <td>{{ dash(agreement.agreement_status) }}</td>
      </tr>
      <tr>
        <th>동의일자</th>
        <td>{{ formatDate(agreement.agreement_date) }}</td>
      </tr>
      <tr>
        <th>은행 동의상태</th>
        <td>{{ dash(agreement.bank_agreement_status) }}</td>
      </tr>
      <tr>
        <th>은행 동의일자</th>
        <td>{{ formatDate(agreement.bank_agreement_date) }}</td>
      </tr>
      <tr>
        <th>동의수단</th>
        <td>{{ dash(agreement.agreement_way) }}</td>
      </tr>
    </table>

    <strong class="t-cont-title text-center mt-10" v-else>{{
      agreementEmptyMessage
    }}</strong>

    <div class="aw-actions" v-if="agreement">
      <button
        type="button"
        class="aw-actions__button"
        :disabled="historyLoading"
        @click="openHistories"
      >
        {{ historyLoading ? "조회중..." : "출금 내역 조회" }}
      </button>
    </div>

    <AutoWithdrawListDialog
      v-model="isHistoryDialogOpen"
      :items="histories"
      :loading="historyLoading"
    />
  </v-container>
</template>

<script>
import { getAutoWithdrawAgreement, getAutoWithdrawHistories } from "@/api/contract.js";
import AutoWithdrawListDialog from "@/components/Contract/AutoWithdrawListDialog.vue";
import { hyphen } from "@/utils/filter.js";

export default {
  name: "AutoWithdrawInfo",
  components: {
    AutoWithdrawListDialog, // 자동출금 출금내역 팝업
  },
  data() {
    return {
      agreement: null,
      agreementLoading: false,
      agreementEmptyMessage: "자동출금 동의정보가 없습니다.",
      histories: [],
      historyLoading: false,
      isHistoryLoaded: false,
      isHistoryDialogOpen: false,
    };
  },
  computed: {
    home() {
      return this.$store.getters.getHome;
    },
  },
  methods: {
    dash(val) {
      return val === null || val === undefined || val === "" ? "-" : val;
    },
    mobile(val) {
      return val ? hyphen(val) : "-";
    },
    formatDate(dt) {
      if (!dt) return "-";

      const v = String(dt);
      const date = `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 8)}`;

      // 동의일자는 YYYYMMDDHHmmss(14자리)로 내려온다
      if (v.length === 14) {
        return `${date} ${v.slice(8, 10)}:${v.slice(10, 12)}:${v.slice(12, 14)}`;
      }
      if (v.length === 8) return date;
      return v;
    },
    getAgreement() {
      this.agreementLoading = true;

      getAutoWithdrawAgreement(this.home.id)
        .then((result) => {
          this.agreement = result.data;
        })
        .catch((_) => {
          this.agreement = null;
          this.agreementEmptyMessage = "자동출금 동의정보를 조회할 수 없습니다.";
        })
        .finally(() => {
          this.agreementLoading = false;
        });
    },
    openHistories() {
      this.isHistoryDialogOpen = true;

      // 한 번 조회한 내역은 다시 호출하지 않는다
      if (this.isHistoryLoaded) return;

      this.historyLoading = true;

      getAutoWithdrawHistories(this.home.id)
        .then((result) => {
          this.histories = result.data;
          this.isHistoryLoaded = true;
        })
        .catch((_) => {
          this.histories = [];
          this.isHistoryDialogOpen = false;
          this.$store.commit("ERROR", "출금 내역을 조회할 수 없습니다.");
        })
        .finally(() => {
          this.historyLoading = false;
        });
    },
  },
  created() {
    this.getAgreement();
  },
};
</script>

<style scoped>
.aw-notice {
  margin: 0 0 12px;
  text-align: left;
  font-size: 12px;
  line-height: 18px;
  color: #909090;
}

.aw-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 0;
}

.aw-loading p {
  margin: 0;
  color: #444444;
  font-size: 14px;
}

.aw-actions {
  margin: 20px 0 4px;
}

.aw-actions__button {
  width: 100%;
  height: 44px;
  border: 1px solid #ef761d;
  border-radius: 6px;
  background-color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  color: #ef761d;
}

.aw-actions__button:disabled {
  border-color: #d9d9d9;
  color: #b8b8b8;
}
</style>
